export default __webpack_public_path__ + "static/media/SPADE.fcb94d40.png";